<template>
    <div>
        <v-container justify-start pb-0>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">Rosters</div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style to="/admin/rosters" v-bind:exact="exact">Rosters</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-btn flat small color="primary" class="mb-3 mt-3" to="/admin/rosters/new" right>New Roster</v-btn>
        </v-container>

        <rosters-grid v-bind:admin="admin" v-bind:rosters="rosters_season" v-bind:administration="administration"></rosters-grid>
    </div>
</template>

<script>
import RostersGrid from './RostersGrid'

export default {
    name: 'AdminRosters',
    data() {
        return {
            exact: true,
            admin: true,
            administration: true
        }
    },
    components: {
        RostersGrid
    },
    computed: {
        rosters_season() {
            return this.$store.getters.getRostersBySelectedSeason
        }
    }
}
</script>

<style scoped></style>
